import React from "react";
import locale from "@bonliva-crm/locale";
import Select, { OptionType } from "./Select";
import { ValueLabel } from "@graphql";

type Props = {
  className?: string;
  disabled?: boolean;
  error?: any;
  onChange: (values: string[]) => void;
  options: LabelValue[];
  optionType?: OptionType;
  value: string[] | any;
  multi?: boolean;
  clearable?: boolean;
  transformValue?: (v: ValueLabel) => void;
};

export function DepartmentSelect({
  value,
  onChange,
  options,
  disabled,
  className,
  multi = true,
  optionType = "checkbox",
  error,
  transformValue,
  clearable = true
}: Props) {
  return (
    <Select
      clearable={clearable}
      disabled={disabled}
      error={Boolean(error)}
      multi={multi}
      className={className}
      fullWidth
      optionType={optionType}
      options={options}
      onChange={onChange}
      label={error || locale.SelectSomething(locale.Departments)}
      renderDescriptionInValues={false}
      sortOptions
      value={value}
      transformValue={transformValue}
    />
  );
}
